<template>
    <v-btn-toggle v-model="query.type" borderless active-class="white elevation-4" color="primary" class="grey lighten-4" style="width:100%;border-radius:8px!important" @change="emit">
        <template v-for="{ text, value } in types">
            <v-btn :width="`calc(100% / ${types.length})`" style="border-radius: 8px!important;" v-bind="{ value }" :key="text"> {{ text }} </v-btn>
        </template>
    </v-btn-toggle>
</template>

<script>
import { USER_DEPOSIT_TYPES } from "@/store/user-deposits";
const initQuery = (form = {}) => ({
    ...(form || {}),
    type: form?.type || null,
});

const types = [{ text: "전체", value: null }].concat(...Object.values(USER_DEPOSIT_TYPES));
export default {
    data: () => ({
        query: initQuery(),

        types,
    }),
    methods: {
        sync() {
            this.query = initQuery(this.$route.query);
        },
        emit() {
            let { ...query } = this.query;

            delete query.page;

            if (!query.type) delete query.type;

            this.$router.push({ query });
        },
    },
    watch: {
        "$route.query"() {
            this.sync();
        },
    },
    mounted() {
        this.sync();
    },
};
</script>

<style lang="scss" scoped>
.v-btn-toggle > .v-btn.v-btn--active {
    opacity: 1;
}
.theme--light.v-btn-toggle:not(.v-btn-toggle--group) .v-btn.v-btn--active.white {
    border-width: 1px;
    border-style: solid;
    border-color: var(--v-primary-base) !important;
}
</style>
